// Strings of the shared UI components (lib/ui, lib/charts) and the style guide.
// Every component that shows one of these imports this file.
import { registerMessages } from '../i18n.svelte';

registerMessages({
  nl: {
    'ui.close': 'Sluiten',
    'ui.back': 'Terug',
    'ui.clear': 'Wissen',
    'ui.done': 'Klaar',
    'ui.ok': 'OK',
    'ui.all': 'Alle',
    'ui.dismiss': 'Melding sluiten',
    'ui.optional': 'optioneel',
    'ui.search': 'Zoeken',
    'ui.search_placeholder': 'Zoeken…',
    'ui.search_shortcut': 'Druk op {key} om te zoeken',
    'ui.no_results': 'Geen resultaten',
    'ui.open_list': 'Lijst openen',
    'ui.create_option': '"{name}" toevoegen',
    'ui.clear_filters': 'Filters wissen',
    'ui.clear_filter': 'Filter {name} wissen',
    'ui.n_selected': '{count} geselecteerd',
    'ui.remove': '{name} verwijderen',
    'ui.clear_selection': 'Selectie opheffen',
    'ui.bulk_label': 'Acties voor de selectie',
    'ui.step_of': 'Stap {current} van {total}',
    'ui.progress': 'Voortgang',
    'ui.loading': 'Laden…',
    'ui.from': 'Van',
    'ui.to': 'Tot',
    'ui.goal': 'Doel',
    'ui.less': 'Minder',
    'ui.more': 'Meer',
    'ui.characters': '{count}/{max}',
    'ui.time_placeholder': 'uu:mm',
    'ui.trend_up': 'Gestegen met {value}',
    'ui.trend_down': 'Gedaald met {value}',
    'ui.trend_flat': 'Gelijk gebleven',

    'payment.open': 'Openstaand',
    'payment.partial': 'Deels betaald',
    'payment.paid': 'Betaald',
    'payment.non_billable': 'Niet factureerbaar',
    'payment.cycle_hint': 'Klik om de status te wijzigen',

    'styleguide.title': 'Stijlgids',
    'styleguide.subtitle': 'Alle design tokens en componenten van Timepeak, live in het huidige thema.',
    'styleguide.preview': 'Voorbeeld',
    'styleguide.theme': 'Thema',
    'styleguide.accent': 'Accent',
    'styleguide.light': 'Licht',
    'styleguide.dark': 'Donker',
    'styleguide.preview_hint': 'Alleen voor deze pagina; je voorkeuren veranderen niet.',
    'styleguide.contents': 'Inhoud',
    'styleguide.s.brand': 'Merk',
    'styleguide.s.colors': 'Kleuren',
    'styleguide.s.type': 'Typografie',
    'styleguide.s.spacing': 'Ruimte',
    'styleguide.s.radius': 'Afronding',
    'styleguide.s.elevation': 'Schaduw & focus',
    'styleguide.s.layers': 'Lagen (z-index)',
    'styleguide.s.buttons': 'Knoppen',
    'styleguide.s.badges': 'Badges, chips & stippen',
    'styleguide.s.forms': 'Formulieren',
    'styleguide.s.filters': 'Filters & zoeken',
    'styleguide.s.choices': 'Keuzes & voortgang',
    'styleguide.s.feedback': 'Meldingen & lege staten',
    'styleguide.s.stats': 'Cijfers',
    'styleguide.s.lists': 'Secties, rijen & registraties',
    'styleguide.s.overlays': 'Dialogen, menu’s & selectie',
    'styleguide.s.layout': 'Paginakop & kaarten',
    'styleguide.s.prose': 'Lange tekst',
    'styleguide.s.charts': 'Grafieken',
    'styleguide.brand_neutral': 'Neutralen',
    'styleguide.brand_status': 'Status',
    'styleguide.brand_chart': 'Grafiekpalet',
    'styleguide.brand_client': 'Klantkleuren',
    'styleguide.brand_scale': 'Merkschaal (volgt het accent)',
    'styleguide.sample_text': 'Uren bijhouden zonder gedoe',
    'styleguide.open_modal': 'Dialoog openen',
    'styleguide.open_bare': 'Kale dialoog',
    'styleguide.open_fullscreen': 'Volledig scherm',
    'styleguide.open_drawer': 'Lade openen',
    'styleguide.modal_text': 'Dialogen gebruiken --z-modal, sluiten met Escape en houden de focus vast.',
    'styleguide.show_bulk': 'Selectiebalk tonen',
    'styleguide.sample_notice': 'Dit is een melding. Gebruik hem voor uitleg, waarschuwingen en fouten in de pagina.',
    'styleguide.sample_empty': 'Nog geen registraties',
    'styleguide.sample_empty_hint': 'Start de timer of voeg handmatig tijd toe.'
  },
  en: {
    'ui.close': 'Close',
    'ui.back': 'Back',
    'ui.clear': 'Clear',
    'ui.done': 'Done',
    'ui.ok': 'OK',
    'ui.all': 'All',
    'ui.dismiss': 'Dismiss',
    'ui.optional': 'optional',
    'ui.search': 'Search',
    'ui.search_placeholder': 'Search…',
    'ui.search_shortcut': 'Press {key} to search',
    'ui.no_results': 'No results',
    'ui.open_list': 'Open list',
    'ui.create_option': 'Add "{name}"',
    'ui.clear_filters': 'Clear filters',
    'ui.clear_filter': 'Clear filter {name}',
    'ui.n_selected': '{count} selected',
    'ui.remove': 'Remove {name}',
    'ui.clear_selection': 'Clear selection',
    'ui.bulk_label': 'Actions for the selection',
    'ui.step_of': 'Step {current} of {total}',
    'ui.progress': 'Progress',
    'ui.loading': 'Loading…',
    'ui.from': 'From',
    'ui.to': 'To',
    'ui.goal': 'Goal',
    'ui.less': 'Less',
    'ui.more': 'More',
    'ui.characters': '{count}/{max}',
    'ui.time_placeholder': 'hh:mm',
    'ui.trend_up': 'Up {value}',
    'ui.trend_down': 'Down {value}',
    'ui.trend_flat': 'Unchanged',

    'payment.open': 'Outstanding',
    'payment.partial': 'Partly paid',
    'payment.paid': 'Paid',
    'payment.non_billable': 'Non-billable',
    'payment.cycle_hint': 'Click to change the status',

    'styleguide.title': 'Style guide',
    'styleguide.subtitle': 'Every Timepeak design token and component, live in the current theme.',
    'styleguide.preview': 'Preview',
    'styleguide.theme': 'Theme',
    'styleguide.accent': 'Accent',
    'styleguide.light': 'Light',
    'styleguide.dark': 'Dark',
    'styleguide.preview_hint': 'This page only; your preferences do not change.',
    'styleguide.contents': 'Contents',
    'styleguide.s.brand': 'Brand',
    'styleguide.s.colors': 'Colours',
    'styleguide.s.type': 'Typography',
    'styleguide.s.spacing': 'Spacing',
    'styleguide.s.radius': 'Radius',
    'styleguide.s.elevation': 'Elevation & focus',
    'styleguide.s.layers': 'Layers (z-index)',
    'styleguide.s.buttons': 'Buttons',
    'styleguide.s.badges': 'Badges, chips & dots',
    'styleguide.s.forms': 'Forms',
    'styleguide.s.filters': 'Filters & search',
    'styleguide.s.choices': 'Choices & progress',
    'styleguide.s.feedback': 'Notices & empty states',
    'styleguide.s.stats': 'Numbers',
    'styleguide.s.lists': 'Sections, rows & entries',
    'styleguide.s.overlays': 'Dialogs, menus & selection',
    'styleguide.s.layout': 'Page header & cards',
    'styleguide.s.prose': 'Long text',
    'styleguide.s.charts': 'Charts',
    'styleguide.brand_neutral': 'Neutrals',
    'styleguide.brand_status': 'Status',
    'styleguide.brand_chart': 'Chart palette',
    'styleguide.brand_client': 'Client colours',
    'styleguide.brand_scale': 'Brand scale (follows the accent)',
    'styleguide.sample_text': 'Track your hours without the hassle',
    'styleguide.open_modal': 'Open dialog',
    'styleguide.open_bare': 'Bare dialog',
    'styleguide.open_fullscreen': 'Full screen',
    'styleguide.open_drawer': 'Open drawer',
    'styleguide.modal_text': 'Dialogs use --z-modal, close on Escape and trap focus.',
    'styleguide.show_bulk': 'Show selection bar',
    'styleguide.sample_notice': 'This is a notice. Use it for explanations, warnings and errors inside the page.',
    'styleguide.sample_empty': 'No time entries yet',
    'styleguide.sample_empty_hint': 'Start the timer or add time manually.'
  }
});
